<section style="color: var(--page-accent);">
  <div *ngFor="let slotable of contentModule.slotables" class="mt-8 sm:mt-12 w-full">
    <app-slot-a60 [slotable]="slotable"
                  [image]="contentModule.image"></app-slot-a60>
  </div>
</section>

